import React from "react";
import { Popover, OverlayTrigger } from "react-bootstrap";

const sharedWithDetails = (props) => {
  return props.isPopover ? (
    <OverlayTrigger
      trigger={["hover", "focus"]}
      key={props.sKey}
      placement="bottom-start"
      overlay={
        <Popover id="popover-trigger-focus">
          <Popover.Content className="sharedwith-popover">
            <div className="row">
              <div className="col">
                <div>
                  {props.profile ? (
                    <img
                      className="sharedwith-popover-profile "
                      src={props.profile}
                      alt="profile"
                      width="36"
                      height="36"
                      style={{ borderRadius: 18 }}
                    />
                  ) : (
                    <div className="sharedwith-popover-intials pt-1">
                      {props.nameIntial}
                    </div>
                  )}
                </div>
              </div>
              <div className="sharedwith-popover-col pl-0 col">
                <div className="shared-with-title">{props.personName}</div>
                <div className="sharedwith-popover-role">{props.isFromActivity ? props.email : props.role}</div>
              </div>
            </div>
          </Popover.Content>
        </Popover>
      }
    >
      <div>
        {props.profile ? (
          <img
            className="sharedwith-details"
            src={props.profile}
            alt="profile"
            width="24"
            height="24"
            style={{ borderRadius: "50%" }}
          />
        ) : (
          <div className="sharedwith-details-initials pt-1">
            {props.nameIntial}
          </div>
        )}
      </div>
    </OverlayTrigger>
  ) : (
    <div>
      {props.profile ? (
        <img
          className="sharedwith-details"
          src={props.profile}
          alt="profile"
          width="24"
          height="24"
          style={{ borderRadius: "50%" }}
        />
      ) : (
        <div className="sharedwith-details-initials pt-1">
          {props.nameIntial}
        </div>
      )}
    </div>
  );
};

export default sharedWithDetails;
